import { render, staticRenderFns } from "./iconSend.vue?vue&type=template&id=4e0c2d13"
import script from "./iconSend.vue?vue&type=script&lang=js"
export * from "./iconSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports